<template>
  <div>
    <span>{{ viewport }}</span>
    <select v-model="token">
      <option v-for="value in availableLayouts" :key="value" :value="value">{{ value }}</option>
      <option value="add-new">+ add other</option>
    </select>

    <select v-model="backendEnvironment">
      <option value="release">Release</option>
      <option value="prerelease">Prerelease</option>
      <option value="development">Development</option>
      <option value="localhost">Localhost</option>
    </select>
  </div>
</template>

<script>

import {MoqoApi} from '@/lib/MoqoApi.js'

export default {
  name: 'debug-switch',
  props: {
    layout: {
      type: String,
      required: false
    },

    backendEnv: {
      type: String,
      default: 'release'
    }
  },

  watch: {
    token() {
      if (this.token == 'add-new') {
        this.addNewToken()
        return
      }
      localStorage.setItem('teamToken', this.token)
      this.$emit('selectTeam', this.token)
    },

    backendEnvironment() {
      localStorage.setItem('backendEnv', this.backendEnvironment)
      this.$emit('selectBackendEnv', this.backendEnvironment)
    }
  },

  data() {
    return {
      viewport: null,
      token: this.layout,
      backendEnvironment: this.backendEnv,
      availableLayouts: []
    }
  },

  methods: {

    addNewToken () {
      let newToken = prompt('Please enter token:')
      MoqoApi.getEcp(newToken).then(response => {
        if (response.data.team) {
          this.saveToken(newToken)
          this.token = newToken
        } else {
          alert('Not found')
        }
      }).catch(error => {
        alert('Not found')
      })
    },

    saveToken (token) {
      if (this.availableLayouts.indexOf(token) < 0) {
        this.availableLayouts.push(token)
      }
      localStorage.setItem('teamsite-selection', JSON.stringify(this.availableLayouts))
    }

  },

  mounted() {
    let savedSelections = localStorage.getItem('teamsite-selection')
    if(savedSelections) {
      this.availableLayouts = JSON.parse(savedSelections)
    }

    this.$bus.$on('viewport-change', (viewport)=>{this.viewport = viewport})
    this.$nextTick(() => {
      this.$bus.$emit('get-viewport')
    })
  }
}
</script>

<style lang="scss" scoped>
span {
  float: left;
}
div{
  position: fixed;
  top: 5px;
  right: 5px;
  z-index: 9999;
  opacity: 0.3;
  @include breakpoint(small only) {
    right: 20%;
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 2px;
    background: gray;
  }
  &:hover {
    opacity: 1;
  }
}
select{
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/DebugSwitch.vue